export interface IIndexable<D = unknown> {
  [index: string]: D;
  [index: number]: D;
}

export function mapKeys<V, T> (obj: IIndexable<V>, mapfn: (item: V) => T): T[] {
  return Object.keys(obj).map(k => mapfn(obj[k]));
}
